import { configureStore } from '@reduxjs/toolkit';

import chamberReducer from './chamberSlice';
import employeeReducer from './employeeSlice';
import warehouseReducer from './warehouseSlice';

const store = configureStore({
  reducer: {
    warehouse: warehouseReducer,
    chamber: chamberReducer,
    employee: employeeReducer
  }
});

export default store;
